export default "__VITE_ASSET__2e950485__"